export default __webpack_public_path__ + "static/media/callred.7ec8819f.svg";